import axios from "axios";

export default {
  namespaced: true,

  state: {
    teams: [],
    team: {},
    search_teams: [],
  },

  getters: {
    teams(state) {
      return state.teams;
    },
    team(state) {
      return state.team;
    },
    search_teams(state) {
      return state.teams;
    },
  },

  mutations: {
    SET_TEAMS(state, teams) {
      return (state.teams = teams);
    },

    SET_TEAM(state, team) {
      return (state.team = team);
    },
    SET_SEARCH_TEAMS(state, teams) {
      return (state.search_teams = teams);
    },
  },

  actions: {
    async fetchTeams({ commit }, params) {
      await axios
        .get("/api/v1/teams", { params: params })
        .then((res) => {
          commit("SET_TEAMS", res.data);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },

    async fetchSearchTeams({ commit }, params) {
      await axios
        .get("/api/v1/teams", { params: params })
        .then((res) => {
          // console.log(res.data.data);
          commit("SET_SEARCH_TEAMS", res.data);

          // return res.data;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },

    async fetchTeam({ commit }, params) {
      let team_id = params?.team_id ?? params;
      return await axios
        .get(`/api/v1/teams/${team_id}`)
        .then((res) => {
          commit("SET_TEAM", res.data);
          return res.data;
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },

    // these four resolve with the response and leave refreshing to the caller,
    // which knows the filters the list is showing. they used to gate on
    // res.statusText, which is empty over HTTP/2 and never "OK" on a 201.
    async createTeam({ commit }, team) {
      return await axios
        .post("/api/v1/teams", team)
        .then((res) => res.data)
        .catch((err) => {
          return Promise.reject(err);
        });
    },

    async updateTeam({ commit }, team) {
      return await axios("/api/v1/teams/" + team.team_id, {
        method: "put",
        data: team,
      })
        .then((res) => res.data)
        .catch((err) => {
          return Promise.reject(err);
        });
    },

    async deleteTeam({ commit }, team_id) {
      return await axios
        .delete(`/api/v1/teams/${team_id}`)
        .then((res) => res.data)
        .catch((err) => {
          return Promise.reject(err);
        });
    },

    async attachCustomerToTeam({ commit }, team) {
      return await axios
        .post("/api/v1/teams/assign-team", team)
        .then((res) => res.data)
        .catch((err) => {
          return Promise.reject(err);
        });
    },
  },
};
